import { render, staticRenderFns } from "./AccompanyInsurersTable.vue?vue&type=template&id=60228430"
import script from "./AccompanyInsurersTable.vue?vue&type=script&lang=js"
export * from "./AccompanyInsurersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports